(function () {
  const mobile = window.matchMedia('(max-width: 768px)');
  const isOpen = 'footer__navigation-header--open';
  const trigger = qsa('.js-footer_navigation-header');
  const list = qsa('.js-footer-navigation-list');

  var lastActiveTool;

  trigger.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (mobile.matches) { 
        const parent = e.currentTarget.closest('.js-footer__navigation');
        const content = parent.querySelector('.js-footer-navigation-list');     
        if (e.target.classList.contains(isOpen)) {
          e.currentTarget.classList.remove(isOpen)
          content.style.height = '0';

        } else {
          const list = qsa('.js-footer-navigation-list');    
          trigger.forEach((item) => {
            item.classList.remove(isOpen);
          });
          list.forEach(item => {
            item.style.height = 0;
          })
          
          e.currentTarget.classList.add(isOpen);
          content.style.height = `${content.scrollHeight}px`;
        }
      }
    });
    mobile.addEventListener('change', () => {
      if (!mobile.matches) {
        item.classList.remove(isOpen);
    
        list.forEach((el) => {
          el.removeAttribute('style');
        });
      }
    });
  });

  let firstVisit = false;
  checkFirstVisit();
  function checkFirstVisit(){
    if(sessionStorage.getItem('was_visited')){
      return;
    }
    firstVisit = true;
    sessionStorage.setItem('was_visited', 1);
  }
  fetch('/browsing_context_suggestions.json')
  .then(res => res.json())
  .then(res => {
    const marketCountries = ['ie','de','at','it','es','pt','be','nl','lu','dk','se','fi','ee','lv','lt','pl','gr','cz','hr','si','bg','hu','es','pt','pt'];
    let country = document.querySelector('html').dataset.countryCode.toUpperCase();
    let market_lang = document.querySelector('html').getAttribute('lang');
    
    if (!marketCountries.includes(country.toLowerCase())) {
      country = 'ES';
    }
      
    let path = window.location.pathname.split('/')[1];
    let listItem = document.querySelector(`[key^=${country}] a`);

    if(!sessionStorage.getItem('current_market_country')) {
      sessionStorage.setItem('current_market_country', country);
      sessionStorage.setItem('current_market_lang', market_lang);
    } else {
      const localCurrentCountry = sessionStorage.getItem('current_market_country');
      const localCurrentLanguage = sessionStorage.getItem('current_market_lang');
  
      if(localCurrentLanguage !== market_lang) {
        document.cookie = `localization=${localCurrentCountry};path=/${path}`;
        sessionStorage.setItem('current_market_lang', market_lang);
      }
      
      if(localCurrentCountry !== country && localCurrentLanguage === market_lang) {
        document.cookie = `localization=${country};path=/${path}`;
        sessionStorage.setItem('current_market_country', country);
      }
    }
    
    listItem = document.querySelector(`[key^=${sessionStorage.getItem('current_market_country')}] a`);
    const current = document.querySelectorAll('.footer__country-selector .ly-custom-dropdown-current-inner');
    // current.forEach((c) => {
    //   c.innerText = listItem.innerText.trim();
    // });

  });
})();
